// extracted by mini-css-extract-plugin
export var articlesWrapper = "RecommendedArticlesSection-module--articlesWrapper--58e7d";
export var header = "RecommendedArticlesSection-module--header--44650";
export var recommendedArticles = "RecommendedArticlesSection-module--recommendedArticles--4e983";
export var sectiontitle = "RecommendedArticlesSection-module--sectiontitle--aa5d7";
export var wrapper = "RecommendedArticlesSection-module--wrapper--7a242";